/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// @mui material components
import { Grid, Avatar, Card, Button, Icon, Divider, Box } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import TableData from "./data/rolesTableData";
import { InformacionInicialRoles, UpdateStatusRol } from "store/roles/rolesActions";
import ModalContent from "components/ModalContent";
import Loading from "../../components/loading";
import { store } from "store/store";

function Roles() {
  const usuario = store.getState().login?.usuario;
  const navigate = useNavigate();
  const { rolesUsuarios, isloadingRoles } = useSelector((state) => state.roles);
  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialRoles(dispatch);
  }, []);

  const [openmodalActivate, setopenmodalActivate] = useState(false);
  const [rowSelect, setrowSelect] = useState({});
  const [activarRol, setActivarRol] = useState(false);

  const Author = ({ color, rolUsuario, activo }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <Avatar
        sx={{ opacity: 1, width: 24, height: 24, bgcolor: color, fontWeight: "bold", fontSize: 5 }}
      >
        {" "}
      </Avatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="caption"
          fontWeight="medium"
          sx={{ color: `${activo ? "white" : "red"}`, fontSize: 12 }}
        >
          {rolUsuario}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const columnsRoles = useMemo(
    () => [
      {
        accessorKey: "avatar", //access nested data with dot notation
        header: "Rol",
        size: 150,
        Cell: ({ row }) => {
          return (
            <Author
              color={row.original.colorRol}
              rolUsuario={row.original.rolUsuario}
              activo={row.original.activo}
            />
          );
        },
      },
      {
        accessorKey: "descripcion",
        header: "Descripcion",
        size: 150,
      },
    ],
    []
  );
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const AdministrarRolesUsurio = _.filter(usuarioPermisos, { idPermiso: 40 });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Administración de roles
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right">
                      {AdministrarRolesUsurio.length == 0 ? null : (
                        <Button
                          variant="contained"
                          startIcon={<Icon>add</Icon>}
                          color="primary"
                          size="small"
                          style={{ textTransform: "inherit", background: "#1D1D1B" }}
                          onClick={() => {
                            navigate("/modificarRol", { state: null });
                          }}
                        >
                          Nuevo
                        </Button>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Divider />
              <MDBox pt={3}>
                {isloadingRoles ? (
                  <Loading title={"Procesando por favor espere"} />
                ) : (
                  <TableData
                    columns={columnsRoles}
                    data={rolesUsuarios}
                    EditarRol={(row) => {
                      const { avatar, ...safeRow } = row; // eliminar avatar
                      navigate("/modificarRol", { state: safeRow });
                    }}
                    ActivarRol={(row, active) => {
                      const { avatar, ...safeRow } = row; // eliminar avatar
                      setrowSelect(safeRow);
                      setActivarRol(active);
                      setopenmodalActivate(true);
                    }}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <ModalContent
          title={"Modificar estatus del rol"}
          maxWidth="sm"
          fullWidth={false}
          open={openmodalActivate}
          fullScreen={false}
          handleClose={() => {
            setopenmodalActivate(false);
          }}
          handleAcept={() => {
            UpdateStatusRol(dispatch, rowSelect, activarRol, usuario.idUsuario);
            setopenmodalActivate(false);
          }}
          textAccept={activarRol ? "Activar" : "Desactivar"}
        >
          <MDBox>
            <MDTypography variant="button" color="text" fontWeight="regular">
              ¿Desea {activarRol ? "activar" : "desactivar"} el rol{" "}
              <strong>{`${rowSelect.inicialesRol}: ${rowSelect.rolUsuario}`} </strong>
            </MDTypography>
          </MDBox>
        </ModalContent>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Roles;
